import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import UuidEncoder from 'uuid-encoder';
import { ImagePreloadService } from './preload-images.service';
import { ApiUrlService } from './api-url.service';

// Create Base 36 encoder
const encoder = new UuidEncoder('base36');

@Injectable({
    providedIn: 'root'
})
export class UtilsService {

    private loading = new BehaviorSubject<any>(false);
    private WarningsSpaces = new BehaviorSubject<number>(0);

    constructor(private preload: ImagePreloadService, private apiUrlService: ApiUrlService) { }

    /**
     * Tier del backend realmente activo (qa/dev/pro), pasado a través desde
     * ApiUrlService. Úsalo en vez de environment.env para cualquier decisión que
     * dependa del entorno: en webcomponent el host puede pisar la API en runtime
     * vía el atributo api-url, dejando environment.env (fijado en build time)
     * desactualizado respecto al backend contra el que realmente se habla.
     */
    get runtimeEnv(): string {
        return this.apiUrlService.runtimeEnv;
    }

    /** URL del websocket de notificaciones para el backend realmente activo. Ver ApiUrlService.notificationsUrl. */
    get notificationsUrl(): string {
        return this.apiUrlService.notificationsUrl;
    }

    /**
     * Nº de dígitos del código OTP a mostrar. Se basa en organización + tier del
     * backend realmente activo (ApiUrlService), igual que scraperMock.
     */
    getOTPMinLength(): number {
        const runtimeEnv = this.runtimeEnv;
        if (!runtimeEnv) return 6;
        const organization = this.apiUrlService.organization;
        if (runtimeEnv === 'dev' && organization === 'belender') return 6;
        if (runtimeEnv === 'qa' || (runtimeEnv === 'dev' && organization === 'opendata')) return 3;
        return 6;
    }

    setLoading(b: any) {
        this.loading.next(b);
    }

    getLoading() {
        return this.loading.asObservable();
    }

    setWarningsSpaces(b: number) {
        this.WarningsSpaces.next(b);
    }

    getWarningsSpaces() {
        return this.WarningsSpaces.asObservable();
    }

    public uuidv4() {
        return encoder.encode(this.uuidv4Aux());
    }

    uuidv4Aux() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    formatDate(date: string) {
        if(date) {
            let arr = date.split('/');
            if(arr[2]) {
                return arr[2] + '-' + arr[1] + '-' + arr[0];
            }
            return date;
        } else {
            return date;
        }

    }

    /**
     * Check de poder digital: si la solicitud ya está persistida (requestID) y trae
     * power_activate definido (true o false), esa decisión manda sobre la config del
     * backoffice. Si no, se usa data.config.activatePower.
     */
    isPowerActivateEnabled(requestID: string | null | undefined, solicitud: any, config: any): boolean {
        const hasPersistedValue = !!requestID && !!solicitud && solicitud.power_activate !== undefined;
        return hasPersistedValue ? !!solicitud.power_activate : !!config?.activatePower;
    }

    sleep(ms: number): Promise<void> {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    async preloadImages(flowConfig, funderStyles) {
      return new Promise(async (resolve) => {
        let arrayImages = [];
        if(flowConfig?.texts?.form?.customImage) {
          arrayImages.push(flowConfig?.texts?.form?.customImage)
        }
        if(funderStyles?.withLogo && funderStyles?.logoUrl) {
          arrayImages.push(funderStyles.logoUrl)
        }

        this.preload.preload(arrayImages).then(async () => {
            await this.sleep(200);
            resolve(true);
          }).catch(async e => {
            await this.sleep(200);
            resolve(true);
          })
      })
    }
}
